import React from 'react';
import './styles.css';

const Container = ({ ...props }) => {
  return (
    <div className='flex-1 flex-columns week-rooms-overview-container'>
      { props.children }
    </div>
  );
};

export default Container;
